/* Ronsoco contact page: field checks, characters-left counter and the "Send with photos" box */
(() => {
  const init = (form) => {
    if (form.dataset.rcfReady) return;
    form.dataset.rcfReady = 'true';
    // With script, our own messages replace the browser's; without it, the browser still checks required fields
    form.noValidate = true;

    const fields = [...form.querySelectorAll('[data-rcf-error]')];
    const message = form.querySelector('[data-rcf-message]');
    const count = form.querySelector('[data-rcf-count]');
    const subject = form.querySelector('[data-rcf-subject]');
    const photos = form.querySelector('[data-rcf-photos-box]');
    const photosLink = form.querySelector('[data-rcf-photos-link]');

    const showError = (field, show) => {
      const wrap = field.closest('.rcf__field');
      const error = document.getElementById(`${field.id}-error`);
      wrap?.classList.toggle('is-invalid', show);
      if (show) {
        field.setAttribute('aria-invalid', 'true');
        field.setAttribute('aria-describedby', [error?.id, field.id === 'RonsocoContact-body' ? 'RonsocoContact-count' : ''].filter(Boolean).join(' '));
      } else {
        field.removeAttribute('aria-invalid');
        if (field.id === 'RonsocoContact-body') field.setAttribute('aria-describedby', 'RonsocoContact-count');
        else field.removeAttribute('aria-describedby');
      }
      if (error) {
        error.textContent = show ? field.dataset.rcfError : '';
        error.hidden = !show;
      }
    };

    const check = (field) => {
      const value = field.value.trim();
      const ok = value !== '' && (field.type !== 'email' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value));
      showError(field, !ok);
      return ok;
    };

    fields.forEach((field) => {
      const event = field.tagName === 'SELECT' ? 'change' : 'blur';
      field.addEventListener(event, () => check(field));
      field.addEventListener('input', () => {
        if (field.getAttribute('aria-invalid')) check(field);
      });
    });

    const updateCount = () => {
      if (!message || !count) return;
      const left = Math.max(0, Number(count.dataset.max) - message.value.length);
      count.textContent = count.dataset.text.replace('[count]', left.toLocaleString('en-US'));
    };
    message?.addEventListener('input', updateCount);
    updateCount();

    const photosDone = form.querySelector('[data-rcf-photos-done]');
    const value = (id) => form.querySelector(`#RonsocoContact-${id}`)?.value.trim() || '';

    // "Send with photos": the whole form goes into one email in the customer's own app, so photos can be attached
    const buildMail = () => {
      const option = subject.selectedOptions[0];
      const orderNumber = value('order');
      const title = [option.value, orderNumber ? `Order ${orderNumber}` : ''].filter(Boolean).join(' – ');
      const body = [
        `Title: ${value('title')}`,
        `Name: ${[value('first'), value('last')].filter(Boolean).join(' ')}`,
        `Country/Region: ${value('country')}`,
        `Email: ${value('email')}`,
        `Subject: ${option.value}`,
        `Order number: ${orderNumber}`,
        '',
        value('body'),
        '',
        '(Photos attached)',
      ].join('\n');
      return `mailto:${photos.dataset.email}?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(body)}`;
    };

    const updatePhotos = () => {
      if (!photos || !subject) return;
      const option = subject.selectedOptions[0];
      photos.hidden = !(option && option.hasAttribute('data-rcf-photos'));
      if (photos.hidden && photosDone) photosDone.textContent = '';
    };
    subject?.addEventListener('change', updatePhotos);

    // A link such as /pages/contact?subject=Return / Refund – Help picks that subject
    const wanted = new URLSearchParams(window.location.search).get('subject');
    if (wanted && subject) {
      const match = [...subject.options].find((option) => option.value && option.value.toLowerCase() === wanted.trim().toLowerCase());
      if (match) subject.value = match.value;
    }
    updatePhotos();

    const firstProblem = () => {
      const bad = fields.filter((field) => !check(field));
      if (bad.length) bad[0].focus();
      return bad.length > 0;
    };

    photosLink?.addEventListener('click', (event) => {
      event.preventDefault();
      if (firstProblem()) return;
      window.location.href = buildMail();
      if (photosDone) photosDone.textContent = photosLink.dataset.done;
    });

    form.addEventListener('submit', (event) => {
      if (firstProblem()) event.preventDefault();
    });
  };

  const start = () => document.querySelectorAll('form.rcf__form').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
